import { styled } from '@mui/material';
import { PickersDay } from '@mui/x-date-pickers';
import type {} from '@mui/x-date-pickers/AdapterLuxon';

export const CustomPickersDay = styled(PickersDay, {
	shouldForwardProp: (prop: string) =>
		!['isStartDate', 'isEndDate', 'isInRange', 'isHovered', 'isSameDate'].includes(prop),
})<{
	isHovered?: boolean;
	isStartDate?: boolean;
	isEndDate?: boolean;
	isInRange?: boolean;
	isSameDate?: boolean;
}>(({ theme, isStartDate, isEndDate, isInRange, isHovered, day, isSameDate }) => ({
	borderRadius: 0,
	margin: '0px',
	transition: 'none',
	'&.MuiPickersDay-today': {
		border: 0,
	},
	...(day.weekday === 1 && {
		borderRadius: '50% 0px 0px 50%',
	}),
	...(day.weekday === 7 && {
		borderRadius: '0px 50% 50% 0px',
	}),
	...(day.day === 1 && {
		borderTopLeftRadius: '50%',
		borderBottomLeftRadius: '50%',
	}),
	...(day.plus({ days: 1 }).month !== day.month && {
		borderTopRightRadius: '50%',
		borderBottomRightRadius: '50%',
		...(isInRange && {
			'&:focus': {
				background: theme.palette.info.main,
			},
		}),
	}),
	'&:hover': {
		border: '1px solid rgb(158, 158, 158) !important',
		borderRadius: '50%',
	},
	...(isInRange && {
		backgroundColor: theme.palette.info.main,
		'&:hover': {
			backgroundColor: theme.palette.info.dark,
		},
	}),
	...((isStartDate || isEndDate) && {
		backgroundColor: theme.palette.primary.main,
		borderRadius: '50%',
		color: 'white',
		'&:hover': {
			backgroundColor: theme.palette.primary.dark,
		},
	}),
	...(isStartDate &&
		!isSameDate && {
			'&::before': {
				content: "''",
				position: 'absolute',
				top: 0,
				bottom: 0,
				background: theme.palette.info.main,
				zIndex: '-1',
				left: '50%',
				right: 0,
			},
		}),
	...(isEndDate &&
		!isSameDate && {
			'&::before': {
				content: "''",
				position: 'absolute',
				top: 0,
				bottom: 0,
				background: theme.palette.info.main,
				zIndex: '-1',
				right: '50%',
				left: 0,
			},
		}),
	...(isHovered &&
		!isInRange && {
			border: '2px dashed rgb(0,0,0,0.12) !important',
			borderLeft: 'none !important',
			borderRight: 'none !important',
			...(day.weekday !== 1 &&
				day.weekday !== 7 &&
				!isStartDate &&
				!isEndDate && { borderRadius: '0px' }),
			...(day.weekday === 1 && { borderLeft: '2px dashed rgb(0,0,0,0.12) !important' }),
			...(day.weekday === 7 && { borderRight: '2px dashed rgb(0,0,0,0.12) !important' }),
		}),
}));
